import axioApi, { setHeader } from 'api/root.api';

export const getArModel = async (secret, projectId, modelId) => {
    const urlEnd = `/editor/project/v1/${projectId}/${modelId}/arasset`;
    setHeader('Authorization', `${secret}`);
    const response = await axioApi.get(urlEnd);
    const result = response.data;
    return result;
};